import { schema } from 'normalizr'

const shopProduct = new schema.Entity('shopProducts', {})

export default shopProduct
